import Firebase from "firebase";
import productList from "./productList.js";

export default {
  data: function() {
    return {};
  },
  computed: {
    $productList: function() {
      return productList;
    },
    $interiors: function() {
      return [
        { label: "Neutraal", value: 1 },
        { label: "Klassiek", value: 1.1 },
        { label: "Industrieel/minimalistisch", value: 1.15 }
      ];
    },
    $wishes: function() {
      return [
        { label: "Geen", value: 1 },
        { label: "Live muziek en/of audio", value: 0.8 },
        { label: "Extra rustig", value: 0.81 },
        { label: "Prikkelarm/beschut", value: 0.7 }
      ];
    },
    $peopleTypes: function() {
      return [
        { label: "Stil aanwezig", value: 0, sabins: [0.25, 0.35, 0.42, 0.46, 0.5, 0.5] },
        { label: "Sprekend aanwezig", value: 1, sabins: [0.03, 0.04, 0.04, 0.05, 0.05, 0.05] }
      ];
    },
    $firestore: function() {
      return Firebase.firestore();
    }
  },
  methods: {
    $setPageTitle: function(value) {
      document.title = `${value}`;
    },
    $getCurrentUserReference: function() {
      return this.$store.getters.getUser.uid;
    },
    $getCurrentDate: function() {
      return new Date();
    },
    $createNewClient: function(data) {
      const newClient = {
        clientName: data.clientName,
        description: data.description,
        contactFirstName: data.contactFirstName,
        contactLastName: data.contactLastName,
        contactEmail: data.contactEmail,
        contactTel: data.contactTel,
        salesOwner: data.salesOwner,
        createdAt: this.$getCurrentDate(),
        createdBy: this.$getCurrentUserReference(),
        lastEditedAt: this.$getCurrentDate(),
        lastEditedBy: this.$getCurrentUserReference(),
        trashed: false
      };
      return newClient;
    },
    $editClientDataObject: function(data) {
      const editedClient = {
        clientName: data.clientName,
        description: data.description,
        contactFirstName: data.contactFirstName,
        contactLastName: data.contactLastName,
        contactEmail: data.contactEmail,
        contactTel: data.contactTel,
        salesOwner: data.salesOwner,
        lastEditedAt: new Date(),
        lastEditedBy: this.$getCurrentUserReference()
      };
      return editedClient;
    },
    $deleteClientDataObject: function() {
      const deletedClient = {
        trashed: true,
        lastEditedAt: new Date(),
        lastEditedBy: this.$getCurrentUserReference()
      };
      return deletedClient;
    },
    $createNewProject: function(data) {
      const newProject = {
        projectName: data.projectName,
        description: data.description,
        address: {
          street: data.address.street,
          city: data.address.city,
          houseNumber: data.address.houseNumber,
          postCode: data.address.postCode
        },
        createdAt: this.$getCurrentDate(),
        createdBy: this.$getCurrentUserReference(),
        lastEditedAt: this.$getCurrentDate(),
        lastEditedBy: this.$getCurrentUserReference(),
        trashed: false
      };
      return newProject;
    },
    $editProjectDataObject: function(data) {
      const editedProject = {
        projectName: data.projectName,
        description: data.description,
        address: {
          street: data.address.street,
          city: data.address.city,
          houseNumber: data.address.houseNumber,
          postCode: data.address.postCode
        },
        lastEditedAt: new Date(),
        lastEditedBy: this.$getCurrentUserReference()
      };
      return editedProject;
    },
    $deleteProjectDataObject: function() {
      const deletedProject = {
        trashed: true,
        lastEditedAt: new Date(),
        lastEditedBy: this.$getCurrentUserReference()
      };
      return deletedProject;
    },
    $createNewRoom: function(data) {
      const newRoom = {
        roomName: data.roomName,
        description: data.description,
        height: Number(data.height),
        width: Number(data.width),
        length: Number(data.length),
        type: data.type,
        interior: Number(data.interior),
        people: {
          amount: Number(data.people.amount),
          type: Number(data.people.type)
        },
        wishes: Number(data.wishes),
        createdAt: this.$getCurrentDate(),
        createdBy: this.$getCurrentUserReference(),
        lastEditedAt: this.$getCurrentDate(),
        lastEditedBy: this.$getCurrentUserReference(),
        trashed: false
      };
      return newRoom;
    },
    $editRoomDataObject: function(data) {
      const editedRoom = {
        roomName: data.roomName,
        description: data.description,
        height: Number(data.height),
        width: Number(data.width),
        length: Number(data.length),
        type: data.type,
        interior: Number(data.interior),
        people: {
          amount: Number(data.people.amount),
          type: Number(data.people.type)
        },
        wishes: Number(data.wishes),
        lastEditedAt: new Date(),
        lastEditedBy: this.$getCurrentUserReference()
      };
      return editedRoom;
    },
    $deleteRoomDataObject: function() {
      const deletedRoom = {
        trashed: true,
        lastEditedAt: new Date(),
        lastEditedBy: this.$getCurrentUserReference()
      };
      return deletedRoom;
    },
    $createNewMeasurement: function(data) {
      const newMeasurement = {
        type: data.type,
        label: data.label,
        description: data.description,
        author: data.author,
        date: data.date,
        hz125: Number(data.hz125),
        hz250: Number(data.hz250),
        hz500: Number(data.hz500),
        hz1000: Number(data.hz1000),
        hz2000: Number(data.hz2000),
        hz4000: Number(data.hz4000),
        createdAt: this.$getCurrentDate(),
        createdBy: this.$getCurrentUserReference(),
        lastEditedAt: this.$getCurrentDate(),
        lastEditedBy: this.$getCurrentUserReference(),
        trashed: false
      };
      return newMeasurement;
    },
    $editMeasurementDataObject: function(data) {
      const editedMeasurement = {
        type: data.type,
        label: data.label,
        description: data.description,
        author: data.author,
        date: data.date,
        hz125: Number(data.hz125),
        hz250: Number(data.hz250),
        hz500: Number(data.hz500),
        hz1000: Number(data.hz1000),
        hz2000: Number(data.hz2000),
        hz4000: Number(data.hz4000),
        lastEditedAt: this.$getCurrentDate(),
        lastEditedBy: this.$getCurrentUserReference()
      };
      return editedMeasurement;
    },
    $deleteMeasurementDataObject: function() {
      const deletedMeasurement = {
        trashed: true,
        lastEditedAt: new Date(),
        lastEditedBy: this.$getCurrentUserReference()
      };
      return deletedMeasurement;
    },
    $sortClientsAlphabetically: function(array, property, direction = "down") {
      if (direction == "down") {
        return array.sort((valueA, valueB) => {
          if (valueA.data()[property] < valueB.data()[property]) {
            return -1;
          }
          if (valueA.data()[property] > valueB.data()[property]) {
            return 1;
          }
          return 0;
        });
      } else if (direction == "up") {
        return array.sort((valueA, valueB) => {
          if (valueA.data()[property] > valueB.data()[property]) {
            return -1;
          }
          if (valueA.data()[property] < valueB.data()[property]) {
            return 1;
          }
          return 0;
        });
      }
    },
    $sortProductsAlphabetically: function(array, property) {
      return array.sort((valueA, valueB) => {
        if (valueA[property] < valueB[property]) {
          return -1;
        }
        if (valueA[property] > valueB[property]) {
          return 1;
        }
        return 0;
      });
    },
    $prettifyDate: function(seconds) {
      const currentDate = new Date(1970, 0, 1);
      currentDate.setSeconds(seconds);
      const months = [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
      ];
      const day = currentDate.getDate();
      const monthIndex = currentDate.getMonth();
      const year = currentDate.getFullYear();
      return `${day} ${months[monthIndex]} ${year}`;
    }
  },
  filters: {
    $noDecimals: function(value) {
      return Number(value).toFixed(0);
    },
    $oneDecimal: function(value) {
      return Number(value).toFixed(1);
    },
    $twoDecimals: function(value) {
      return Number(value).toFixed(2);
    },
    $dotToComma: function(value) {
      return String(value).replace(/\./g, ",");
    },
    $prettifyDate: function(seconds) {
      const currentDate = new Date(1970, 0, 1);
      currentDate.setSeconds(seconds);
      const months = [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
      ];
      const day = currentDate.getDate();
      const monthIndex = currentDate.getMonth();
      const year = currentDate.getFullYear();
      return `${day} ${months[monthIndex]} ${year}`;
    },
    $prettifyDateToNumbers: function(seconds) {
      const currentDate = new Date(1970, 0, 1);
      currentDate.setSeconds(seconds);
      let day = currentDate.getDate();
      let month = currentDate.getMonth();
      let year = currentDate.getFullYear();
      month += 1;
      if (day < 10) day = "0" + day;
      if (month < 10) month = "0" + month;
      return `${day}-${month}-${year}`;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/globals.js